// extracted by mini-css-extract-plugin
export default {"container":"ImagedPage_container__uBMM-","reversedContainers":"ImagedPage_reversedContainers__7QTaz","image":"ImagedPage_image__ZT9uy","content":"ImagedPage_content__sNymf"};